module.exports = __webpack_public_path__ + "static/media/CHECKPASCON.f3ea3ed1.png";